import VehicleDetailsSkeleton from "./VehicleDetailsSkeleton";

export default VehicleDetailsSkeleton;
